import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../i18n/LanguageContext";
import "./howItWorks.css";

const content = {
    en: {
        title: "How it works",
        intro: "From reception desk to room door in three simple steps.",
        phoneAlt: "Smart Key app welcome screen",
        steps: [
            { title: "Choose your hotel and sign in", text: "Guests open Smart Key, pick their hotel, then scan the QR code at reception or enter their reservation ID." },
            { title: "Reception approves the phone", text: "Staff confirm the guest's device from the console and the digital key is issued for their room and the length of their stay." },
            { title: "Swipe, speak or tap", text: "The guest opens the door, sets Do Not Disturb and requests hotel services, all from the same app, until check-out." },
        ],
    },
    ar: {
        title: "كيف يعمل",
        intro: "من مكتب الاستقبال إلى باب الغرفة في ثلاث خطوات بسيطة.",
        phoneAlt: "شاشة الترحيب في تطبيق ضياف",
        steps: [
            { title: "اختر فندقك وسجّل الدخول", text: "يفتح الضيف تطبيق ضياف ويختار فندقه، ثم يمسح رمز QR في الاستقبال أو يُدخل رقم الحجز." },
            { title: "الاستقبال يعتمد الهاتف", text: "يؤكد الفريق جهاز الضيف من لوحة التحكم، فيُصدَر المفتاح الرقمي لغرفته طوال مدة إقامته." },
            { title: "مرّر أو تحدّث أو اضغط", text: "يفتح الضيف الباب ويفعّل خاصية عدم الإزعاج ويطلب خدمات الفندق، كل ذلك من التطبيق نفسه حتى المغادرة." },
        ],
    },
};

const HowItWorks = () => {
    const { lang } = useLanguage();
    const c = content[lang];
    return (
        <>
            <Container maxWidth="lg" className="howItWorksSection">
                <Box className="howItWorksPhone">
                    <img src="/icons/smartkey/app-welcome.png" alt={c.phoneAlt} />
                </Box>
                <Box className="howItWorksContent">
                    <Typography variant="h3" gutterBottom>
                        {c.title}
                    </Typography>
                    <Typography variant="subtitle1" className="howItWorksIntro">
                        {c.intro}
                    </Typography>
                    {c.steps.map((step, index) => (
                        <Box className="howItWorksStep" key={index}>
                            <Box className="howItWorksNumber">{index + 1}</Box>
                            <Box>
                                <Typography variant="h5">{step.title}</Typography>
                                <Typography>{step.text}</Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Container>
        </>
    )
}
export default HowItWorks;
